/**
 * Solutions Dropdown Component
 * Navigation dropdown for Solutions menu items
 */

import { Link } from 'react-router-dom';

export function SolutionsDropdown() {
  return (
    <div className="relative group">
      <button
        className="text-neutral-700 hover:text-neutral-900 transition-colors flex items-center gap-1 py-2"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Solutions
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      <div className="absolute left-0 pt-2 w-48 hidden group-hover:block z-50">
        <div className="bg-white rounded-md shadow-lg py-1 border border-neutral-200">
          <Link
            to="/plans/create"
            className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
          >
            Plan Generator
          </Link>
          <Link
            to="/service-providers"
            className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
          >
            Service Providers
          </Link>
          <Link
            to="/docs"
            className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
          >
            Documentation
          </Link>
        </div>
      </div>
    </div>
  );
}
